import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full bg-white py-10 md:py-16 px-6" data-id="element-85">
      <div className="max-w-4xl mx-auto" data-id="element-86">
        <div className="bg-[#1a1a2e] rounded-2xl p-8 md:p-12 mb-8 relative overflow-hidden" data-id="element-87">
          {/* Decorative circles */}
          <div className="absolute -top-10 -right-10 w-40 h-40 bg-[#1a56db] rounded-full opacity-10" data-id="element-88"></div>
          <div className="absolute -bottom-8 -left-8 w-32 h-32 bg-[#1a56db] rounded-full opacity-10" data-id="element-89"></div>

          <div className="relative flex flex-col md:flex-row items-center gap-6 md:gap-10" data-id="element-90">
            <div className="flex-shrink-0" data-id="element-91">
              <div className="w-20 h-20 md:w-24 md:h-24 bg-green-500 rounded-full flex items-center justify-center shadow-lg" data-id="element-92">
                <ShieldCheckIcon className="w-10 h-10 md:w-12 md:h-12 text-white" data-id="element-93" />
              </div>
            </div>
            <div className="text-center md:text-left" data-id="element-94">
              <h2 className="font-black text-2xl md:text-3xl lg:text-4xl mb-4 text-white" data-id="element-95">
                7-Day Ironclad Peace-at-Home Guarantee
              </h2>
              <p className="text-base md:text-lg text-gray-300 leading-relaxed" data-id="element-96">
                Try the protocol tonight. If your home isn't significantly
                quieter and your relationship with your child isn't noticeably
                better within 7 days, email us. We'll give you back your $6.37.{' '}
                <span className="font-bold text-white" data-id="element-97">
                  No questions asked.
                </span>{' '}
                We're here for the kids, not the money.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}